import React, { useState } from 'react';
import api from '../../services/Api';
import { FaEnvelope } from 'react-icons/fa6';
import toast from 'react-hot-toast';
import { BeatLoader } from 'react-spinners';
import bgImage from '../../assets/Left Content.png';
import { useNavigate } from 'react-router-dom';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    const toastId = toast.loading('Sending reset instructions...');
    setIsSubmitting(true);

    try {
      const response = await api.post('/admin/request-forgotten-password', { email });
      console.log(response.data);
      toast.success('Password reset instructions have been sent to your email!', { id: toastId });
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    } catch (err) {
      toast.error(
        err.response?.data?.message || 'Failed to request password reset. Please try again.',
        { id: toastId }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex flex-row overflow-hidden">
      {/* Left side with image */}
      <div className="h-screen col-span-2 bg-center bg-no-repeat bg-auto">
        <img src={bgImage} alt="logo" className="w-full" />
      </div>

      {/* Right side with form */}
      <form
        onSubmit={handleSubmit}
        className="absolute w-[307px] h-[388px] top-[250px] left-[1002px]">
        <div className="w-[191px] h-[54px] text-center mx-auto mb-8">
          <h1 className="text-[26px] font-bold leading-[26.12px] text-transparent bg-clip-text bg-gradient-to-b from-[#333333] to-[#999999]">
            Forgot Password?
          </h1>
          <p className="text-[18px] font-normal text-transparent bg-clip-text bg-gradient-to-b from-[#333333] to-[#999999]">
            We'll help you reset your password
          </p>
        </div>
        <div className="relative mb-2">
          <FaEnvelope className="absolute text-gray-400 transform -translate-y-1/2 left-5 top-1/2" />
          <input
            type="email"
            id="email"
            placeholder="Email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            className={`w-[307px] h-[60px] px-[45px] py-[18px] border rounded-[30px] bg-white focus:outline-none focus:ring-0 placeholder:text-black/25 border-[#EEEEEE]`}
            required
          />
        </div>

        <div className="flex items-center gap-0 mb-2">
          <button
            type="submit"
            className="w-[307px] h-[57px] px-[26px] py-[18px] bg-[#000000] border border-[#000000] text-white rounded-[30px] opacity-100 flex items-center justify-center"
            disabled={isSubmitting}>
            {isSubmitting ? <BeatLoader color="#ffffff" size={10} /> : 'Send Reset Link'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ForgotPassword;
